import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':equipmentCostId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:equipmentCostId`;

export const URL = (equipmentCostId: number): RouteDefinition => `${baseRoute}/${equipmentCostId}`;
